import { useCallback, useEffect, useMemo, useState } from 'react'
import { Transition } from '@headlessui/react'
import { ModalManager, ModalProps } from 'managers/modal/modal-manager'

export const WidgetModal = () => {
  const [modalProps, setModalProps] = useState<ModalProps>({})
  const { children } = modalProps

  const showModal = useCallback((passedProps: ModalProps) => {
    setModalProps({ ...passedProps })
  }, [])

  const hideModal = useCallback(() => {
    setModalProps({})
  }, [])

  const isVisible = useMemo(() => !!children, [children])

  useEffect(() => {
    ModalManager.register({ showModal, hideModal })
  }, [])

  return (
    <>
      <Transition
        show={isVisible}
        enter="tw-transition-opacity tw-duration-300"
        enterFrom="tw-opacity-0"
        enterTo="tw-opacity-100"
        leave="tw-transition-opacity tw-duration-300"
        leaveFrom="tw-opacity-100"
        leaveTo="tw-opacity-0"
      >
        <div
          className={'tw-rounded-5xl tw-bg-gray-900/30'}
          style={{
            position: 'absolute',
            bottom: 0,
            top: 0,
            left: 0,
            right: 0,
            zIndex: 998,
          }}
        />
      </Transition>

      <Transition
        show={isVisible}
        enter="tw-transition-opacity tw-duration-400"
        enterFrom="tw-opacity-0"
        enterTo="tw-opacity-100"
        leave="tw-transition-opacity tw-duration-400"
        leaveFrom="tw-opacity-100"
        leaveTo="tw-opacity-0"
      >
        <div
          className={'tw-rounded-5xl tw-bg-primary-100'}
          style={{
            width: '100%',
            position: 'absolute',
            bottom: 0,
            zIndex: 999,
          }}
        >
          {children}
        </div>
      </Transition>
    </>
  )
}
